import { AnyEventObject } from 'xstate';
import { patchData } from '~/utils/service';
import { DETAILS_ROUTE_NAME } from '../../routes';
import { Scope } from './../../../step-machine/types';
import { CompensationFormValues } from './types';
import { transformCompensationFormToApi } from './utils';

export const API_CALLS = {
  patch: async ({ input }: { input: Scope<CompensationFormValues> }) => {
    const event = input.event as AnyEventObject;
    return await patchData(DETAILS_ROUTE_NAME, {
      pathParams: { id: event.payload.values.id?.toString() || '' },
      data: event.payload.values,
      transformRequest: transformCompensationFormToApi,
    });
  },
};
